import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import Intervention from "../../entity/insurance/Intervention";

const SERVICE = "service-insurance";
const ENTITY = "interventions";

export default function () {
    const {findOneBy, update} = useApi();
    const state = useSelector;
    const newInstance = data => new Intervention(data);

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.insurance?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    return findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application");
                }
            }
        },
        findOneByToken(token) {
            return {
                select() {
                    const result = state(state => state.api?.insurance?.[ENTITY]?.find(i => i?.getToken() === token));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    return findOneBy(SERVICE, ENTITY, "token", token, newInstance, "application");
                }
            }
        },
        findOneBySuggestionId(id) {
            return {
                select() {
                    const result = state(state => state.api?.insurance?.[ENTITY]?.find(i => i?.getSuggestionId() == id));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    return findOneBy(SERVICE, ENTITY, "suggestion_id", id, newInstance, "application");
                }
            }
        },
        async updateCurrentStep(id, payload) {
            return update(SERVICE, ENTITY, id, "current_step", payload, newInstance, "application");
        },
        async skipQuotationSignature(id, signedFileId) {
            return update(SERVICE, ENTITY, id, "quotation_signature/skip", {
                document: {signed_file_id: signedFileId}
            }, newInstance, "application");
        },
        async skipReportCompletionSignature(id, signedFileId) {
            return update(SERVICE, ENTITY, id, "report_completion_signature/skip", {
                document: {signed_file_id: signedFileId}
            }, newInstance, "application");
        }
    }
}
